import script from "./PartnersSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnersSection.vue?vue&type=script&setup=true&lang=js"

import "./PartnersSection.vue?vue&type=style&index=0&id=67730ca0&lang=css"
import "./PartnersSection.vue?vue&type=style&index=1&id=67730ca0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67730ca0"]])

export default __exports__